<template>
  <div class="DefaultLayout bg-gray-100 min-h-screen">
    <Header />
    <slot />
  </div>
</template>
